export default __webpack_public_path__ + "static/playlist-light-mode-24996b46c5b47ba1fd6241cbb0c29a76.mp4";